<div class="ipm-common-arena-beats " [id]="'ipm-beat-list-'+bannerDiscount">
  <ipm-home-bpm-arena [isShowOnlyBanner]="true"></ipm-home-bpm-arena>
  <div class="top-beats-header">
    <h2 class="heading-title">
      Top Beats
      <span>✨</span>
    </h2>
    <button class="play-all-btn" [id]="'ipm-beat-list-'+bannerDiscount" [attr.aria-label]="'Play all beats from grid'" (click)="gotoLatestBeat(bannerDiscount)" id="{{bannerDiscount}}">
      <span class="btn-text">Play All</span>
      <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
        focusable="false">
        <path d="M4 9h8M10 7l2 2-2 2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
  <div class="ipm-beat-list">
    <!-- <ngx-slick-carousel class="carousel" [id]="'ipm-beat-list-'+bannerDiscount" [config]="slideConfig">
      <ng-container *ngFor="let beatObj of (beatListData | splitBeatList : 5); let i = index">
          <ng-container *ngIf="beatObj.length > 0">
              <div ngxSlickItem class="slide">
                <div class="ipm-beat-section-container">
                  <div class="imp-mobile-banner">
                    <div class="img-wrapper">
                      <img src="./assets/imgs/bpm-arena-icon/{{bannerDiscount}}-banner-icon.png" [alt]="bannerDiscount+'_image'">
                    </div>
                  </div>
                  <div class="beat-grid grid-color-{{i + 1}}">
                    <ipm-beats [beatsList]="beatObj" [componentType]="'bpm-arena'"></ipm-beats>
                    <div class="ipm-play-all-list">
                      <button class="ipm-play-all-btn" (click)="gotoLatestBeat(bannerDiscount)">Play All</button>
                    </div>
                  </div>
                </div>
              </div>
          </ng-container>
      </ng-container>
    </ngx-slick-carousel> -->
    <!-- <owl-carousel-o [options]="customOptions" [id]="bannerDiscount+'_slider'"> -->
      
          <!-- <ng-container *ngFor="let beatObj of (beatListData | splitBeatList : 5); let i = index"> -->
          <!-- <ng-container *ngIf="beatObj.length > 0"> -->
            <!-- <ng-template carouselSlide > -->
                 <div class="ipm-beat-section-container">
                  <div class="imp-mobile-banner">
                    <div class="img-wrapper">
                      <img src="./assets/imgs/bpm-arena-icon/{{bannerDiscount}}-banner-icon.png" [alt]="bannerDiscount+'_image'">
                    </div>
                  </div>
                  <div class="ipm-play-all-list">
                      <button class="ipm-play-all-btn" (click)="gotoLatestBeat(bannerDiscount)">Play All</button>
                  </div>
                  <div class="beat-grid grid-color">
                    <ipm-beats [beatsList]="beatListData" [componentType]="'bpm-arena'"></ipm-beats>
                  </div>
                </div>
                <!-- </ng-template> -->
            <!-- </ng-container> -->
            <!-- </ng-container> -->
      <!-- </owl-carousel-o> -->
  </div>
</div>